import { FilterOperatorAbbreviations, MachineModel } from '@agilox/common';
import { HttpInterceptorFn } from '@angular/common/http';

const VEHICLES_ENDPOINT = '/v2/machineMgmt/vehicles';
const MODEL_FILTER_PARAM = `filter[model.${FilterOperatorAbbreviations.UNEQUAL}]`;

export const vehiclesModelFilterInterceptor: HttpInterceptorFn = (request, next) => {
	if (request.method !== 'GET' || !request.url.endsWith(VEHICLES_ENDPOINT)) {
		return next(request);
	}

	return next(
		request.clone({ params: request.params.set(MODEL_FILTER_PARAM, MachineModel.APPLIANCE) })
	);
};
